// Display labels only. Keep the original values in API requests and state.
const LABELS: Record<string, string> = {
  owner: "租户管理员",
  editor: "编辑者",
  viewer: "查看者",
  pending: "待处理",
  accepted: "已接收",
  running: "运行中",
  active: "运行中",
  paused: "已暂停",
  completed: "已完成",
  cancelled: "已取消",
  interrupted: "已中断",
  ended: "已结束",
  failed: "失败",
  error: "异常",
  offline: "离线",
  draining: "停止接收新任务",
  dialing: "拨号中",
  ringing: "振铃中",
  answered: "已接通",
  no_answer: "未接听",
  busy: "忙线",
  amd_detected: "检测到自动应答",
  success: "成功",
  reject_not_interested: "拒绝：不感兴趣",
  reject_busy: "拒绝：暂时忙碌",
  reject_wrong_person: "拒绝：联系对象有误",
  reject_other: "拒绝：其他原因",
  inactivity_timeout: "静默超时",
  user_hangup: "用户挂断",
  pass: "通过",
  warn: "警告",
  fail: "不通过",
  playbooks: "话术",
  voices: "声音",
  gateways: "线路",
  "agent-backends": "智能体服务",
  "api-keys": "API 密钥",
  sessions: "会话",
  calls: "对话记录",
  call_history: "对话记录",
  voice_will_be_copied: "是否复制声音",
  turns: "对话轮次",
  evaluations: "评估记录",
  batches: "批次",
  tts_cache: "语音缓存",
  NORMAL_CLEARING: "正常挂断",
  NO_ANSWER: "未接听",
  NO_USER_RESPONSE: "用户无响应",
  USER_BUSY: "用户忙线",
  ORIGINATOR_CANCEL: "主叫取消",
  CALL_REJECTED: "呼叫被拒绝",
  UNALLOCATED_NUMBER: "号码未分配",
  NORMAL_TEMPORARY_FAILURE: "临时故障",
  RECOVERY_ON_TIMER_EXPIRE: "呼叫超时",
};

export function displayLabel(value: string): string {
  return Object.prototype.hasOwnProperty.call(LABELS, value) ? LABELS[value] : value;
}
